import { useMemo } from 'react'
import { useSelector } from 'react-redux'

import { selectUserConfiguration } from '@/features/domain/user'

interface TimeWindowsValue {
  key: uui.domain.rm.TimeWindow
  values: number[]
}

export function useComputeTimeWindowsValues(
  timeWindows: [uui.domain.rm.TimeWindow?, uui.domain.rm.TimeWindow?],
  timeWindowLevels: number[][],
) {
  const { timeFormat } = useSelector(selectUserConfiguration)

  return useMemo(() => {
    return timeWindows.reduce<TimeWindowsValue[]>((acc, curr, index) => {
      if (!curr) return acc
      const key = curr
      const values = generateValues(index, timeWindowLevels)

      acc.push({
        key,
        values,
      })

      return acc
    }, [])
  }, [timeWindows, timeWindowLevels, timeFormat])
}

function generateValues(index: number, timeWindowLevels: number[][]): number[] {
  return timeWindowLevels.map((twl: number[]) => {
    if (twl[index] === undefined) {
      throw new Error('index not found')
    }
    return twl[index]
  })
}
